import React, { ReactNode } from 'react';
import { CheckCircle } from 'components/shared/DesignSystem/Icons';
import styled from 'styled-components';

const ChecklistDiv = styled.ul`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-top: 24px;
`;

const ChecklistItem = styled.li`
  display: flex;
  align-items: center;
  padding-top: 16px;

  &:first-of-type {
    padding-top: 0px;
  }
`;

const CheckText = styled.div`
  padding-left: 4px;
  margin-top: -2px;
  color: var(--cc_color_text_default);
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
`;

export type ValuePropsChecklistProps = {
  checklistItems: string[] | ReactNode[];
};

const ValuePropsChecklist = ({ checklistItems }: ValuePropsChecklistProps) => (
  <ChecklistDiv>
    {checklistItems.map((item, index) => (
      // eslint-disable-next-line react/no-array-index-key
      <ChecklistItem key={`${index}-value-prop-checklist-item`}>
        <CheckCircle size="small" color="var(--cc_color_text_default)" />
        <CheckText>{item}</CheckText>
      </ChecklistItem>
    ))}
  </ChecklistDiv>
);

export default ValuePropsChecklist;
